import { createCrudActions } from '../utils/crudGenerator';

const formatGames = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchGames,
    create: createGame,
    update: updateGame,
    delete: deleteGames
} = createCrudActions('GAME', "Partida", formatGames);